import axios from 'axios'

export const makeRequest = async (url: string, method = 'GET', headers = {}, data: any = null) => {
  const fullUrl = `https://admin.gtokentool.com/admin-api${url}`
  // console.log(fullUrl, 'fullUrl')

  const isFormData = data instanceof FormData;
  console.log(isFormData, 'isFormData')
  const options = {
    method,
    url: fullUrl,
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }), // 如果是 FormData，Axios 会自动设置 Content-Type
      ...headers,
    },
    data, // 仅在 POST/PUT 请求时发送数据
  }

  try {
    const response = await axios(options).catch(e => {
      console.warn("Metadata 获取失败:", e);
    })
    if (response) {
      return response.data;
    }
  } catch (error) {
    console.error('Request failed', error)
    // throw error
  }
}
